export var getDefaultSvgPropsValues = function getDefaultSvgPropsValues() {
  return {
    width: 20,
    height: 20,
    strokeColor: "#222",
    fillColor: "none"
  };
};